import { APIClient } from "./api_helper";

import * as url from "./url_helper";
import { normalizeShopMenuResponse } from "./menuAvailability";
import axios from "./axiosConfig";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
    const user = localStorage.getItem("authUser");
    if (user) return JSON.parse(user);
    return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
    return getLoggedInUser() !== null;
};

// Register Method
export const postRegister = (data : any) => {
    const payload: Record<string, any> = {
        email: data.email,
        password: data.password,
    };

    const resolvedName = data.name ?? data.first_name ?? data.username;
    if (resolvedName) {
        payload.name = resolvedName;
    }

    if (data.confirm_password ?? data.password_confirmation) {
        payload.password_confirmation = data.confirm_password ?? data.password_confirmation;
    }

    return api.create(url.POST_REGISTER, payload, { withCredentials: true });
};

// Login Method
export const postLogin = (data : any) => api.create(url.POST_LOGIN, data, { withCredentials: true });
export const postLogout = () => api.create(url.POST_LOGOUT, {}, { withCredentials: true });

// postForgetPwd
export const postForgetPassword = async (data: { email: string }) => {
    await axios.get("/sanctum/csrf-cookie", { withCredentials: true });
    return api.create(url.POST_PASSWORD_FORGET, data, { withCredentials: true });
};



export const postResetPassword = async (data: {
    token: string;
    email: string;
    password: string;
    password_confirmation: string;
}) => {
    await axios.get("/sanctum/csrf-cookie", { withCredentials: true });
    return api.create(url.POST_PASSWORD_RESET, data, { withCredentials: true });
};

// Edit profile
export const postProfileUpdate = (data : any) => {
    const payload: Record<string, any> = {};

    const resolvedName = data.name ?? data.username;
    if (resolvedName) {
        payload.name = resolvedName;
    }

    if (data.email) {
        payload.email = data.email;
    }

    if (data.shop_id ?? data.shopId) {
        payload.shop_id = data.shop_id ?? data.shopId;
    }

    return api.update(url.POST_EDIT_PROFILE, payload);
};

export const updatePassword = async (data: {
    current_password: string;
    password: string;
    password_confirmation: string;
}) => {
    await axios.get("/sanctum/csrf-cookie", { withCredentials: true });
    return api.put(url.UPDATE_PASSWORD, data);
};
// ------------------------- WEB -------------------------
// Menu
export const getWebShop = async (params: any) => {
    const response = await api.get(url.GET_WEB_SHOP, params);
    if (response?.data) {
        const normalizedData = normalizeShopMenuResponse(response.data);

        // Normalize hasImage flag from backend
        const shop = normalizedData?.shop;
        if (shop) {
            const hasImage = (shop as any).hasImage ?? (shop as any).has_image;
            (shop as any).hasImage = hasImage !== false;
        }

        response.data = normalizedData;
    }
    return response;
};
export const getWebDetailShopMenu = (menuId : string) => api.get(url.GET_WEB_DETAIL_MENU(menuId), {});
export const getMenus = (params?: Record<string, any>) => api.get(url.GET_MENUS, params ?? {});
export const getMenuDetail = (menuId: string | number) => api.get(url.MENU(menuId), {});
export const createMenu = (data: any) => api.create(url.CREATE_MENU, data);
export const updateMenu = (menuId: string | number, data: any) =>
    api.update(url.MENU(menuId), data);
export const deleteMenu = (menuId: string | number) => api.delete(url.MENU(menuId));
export const updateMenuStatus = (menuId: string | number, data: any) =>
    api.update(url.MENU_STATUS(menuId), data);
export const getMenuCategories = (params?: Record<string, any>) =>
    api.get(url.GET_MENU_CATEGORIES, params ?? {});
export const createMenuCategory = (data: any) => api.create(url.CREATE_MENU_CATEGORY, data);
export const updateMenuCategory = (categoryId: string | number, data: any) =>
    api.update(url.MENU_CATEGORY(categoryId), data);
export const deleteMenuCategory = (categoryId: string | number) =>
    api.delete(url.MENU_CATEGORY(categoryId));
export const reorderMenuCategories = (categoryIds: Array<string | number>) =>
    api.put(url.REORDER_MENU_CATEGORIES, { category_ids: categoryIds });
export const getMenuOptions = (params?: Record<string, any>) =>
    api.get(url.GET_MENU_OPTIONS, params ?? {});
export const getMenuOption = (optionId: string | number) =>
    api.get(url.MENU_OPTION(optionId), {});
export const createMenuOption = (data: any) => api.create(url.CREATE_MENU_OPTION, data);
export const updateMenuOption = (optionId: string | number, data: any) =>
    api.update(url.MENU_OPTION(optionId), data);
export const deleteMenuOption = (optionId: string | number) =>
    api.delete(url.MENU_OPTION(optionId));
export const getMenuOptionValues = (optionId: string | number, params?: Record<string, any>) =>
    api.get(url.MENU_OPTION_VALUES(optionId), params ?? {});
export const createMenuOptionValue = (optionId: string | number, data: any) =>
    api.create(url.MENU_OPTION_VALUES(optionId), data);
export const updateMenuOptionValue = (optionId: string | number, valueId: string | number, data: any) =>
    api.update(url.MENU_OPTION_VALUE(optionId, valueId), data);
export const deleteMenuOptionValue = (optionId: string | number, valueId: string | number) =>
    api.delete(url.MENU_OPTION_VALUE(optionId, valueId));
export const importMenu = (payload: any) => api.create(url.IMPORT_MENU, payload);
// Shop
export const getShopDetail = (_shopId?: string | number) => api.get(url.SHOP, {});
export const updateShopDetail = (_shopId: string | number | undefined, data: any) =>
    api.create(url.SHOP, data);
export const getShopWifi = (_shopId?: string | number) => api.get(url.SHOP_WIFI, {});
export const updateShopWifi = (_shopId: string | number | undefined, data: any) =>
    api.create(url.SHOP_WIFI, data);
export const createOwnShop = (data: { name: string; address: string; phone: string }) =>
    api.create(url.CREATE_OWN_SHOP, data);
export const joinShopByInvite = (data: { invite_code: string }) =>
    api.create(url.JOIN_SHOP_BY_INVITE, data);
export const getShopInviteCode = () => api.get(url.SHOP_INVITE_CODE, {});
export const regenerateShopInviteCode = () => api.create(url.SHOP_INVITE_REGENERATE, {});
export const getPlans = () => api.get(url.GET_PLANS, {});
export const getPlanDetail = (planId: string | number) => api.get(url.GET_PLAN_DETAIL(planId), {});

export const createSubscriptionPayment = (payload: { plan_price_id: number }) =>
    api.create(url.CREATE_SUBSCRIPTION_PAYMENT, payload);
// Order
export const createDraftOrder = (payload?: Record<string, any>) =>
    api.create(url.CREATE_ORDER, payload ?? {});
export const getOrders = (params?: Record<string, any>) =>
    api.get(url.GET_ORDERS, params ?? {});
export const getOrderDetail = (orderId: string | number) => api.get(url.GET_ORDER_DETAIL(orderId), {});
export const getDraftOrders = () => api.get(url.GET_DRAFT_ORDERS);
export const getUnclaimedOrders = (params?: Record<string, any>) =>
    api.get(url.GET_UNCLAIMED_ORDERS, params ?? {});
export const startOrder = (orderId: string | number) => api.put(url.START_ORDER(orderId), {});
export const completeOrder = (orderId: string | number) => api.put(url.COMPLETE_ORDER(orderId), {});
export const deleteOrder = (orderId: string | number) => api.delete(url.DELETE_ORDER(orderId));
export const updateOrderStatus = (orderId: string | number, status: string) =>
    api.put(url.UPDATE_ORDER_STATUS(orderId), { status });
export const addOrderItem = (orderId: string | number, data: any) =>
    api.create(url.ORDER_ITEMS(orderId), data);
export const updateOrderItem = (
    orderId: string | number,
    itemId: string | number,
    data: any,
) => api.update(url.ORDER_ITEM(orderId, itemId), data);
export const deleteOrderItem = (orderId: string | number, itemId: string | number) =>
    api.delete(url.ORDER_ITEM(orderId, itemId));
export const markOrderAsUnclaimed = (orderId: string | number, data?: any) =>
    api.put(url.ORDER_MARK_UNCLAIMED(orderId), data ?? {});
export const markUnclaimedOrderHandled = (orderId: string | number, data?: any) =>
    api.put(url.ORDER_UNCLAIMED_RESOLVE(orderId), data ?? {});

// Public order checkout
export const createPublicOrderPayment = (data: any, idempotencyKey: string) =>
    api.create(url.CREATE_WEB_ORDER, data, {
        headers: {
            "Idempotency-Key": idempotencyKey,
        },
    });
export const callService = (payload: Record<string, any>) =>
    api.create(url.WEB_SERVICE_CALL, payload);

// Tables
export const getTables = (params?: Record<string, any>) => api.get(url.GET_TABLES, params ?? {});
export const getShopTables = (params?: Record<string, any>) => api.get(url.GET_SHOP_TABLES, params ?? {});
export const createTable = (payload: any) => api.create(url.CREATE_TABLE, payload);
export const updateTable = (tableId: string | number, payload: any) =>
    api.update(url.TABLE(tableId), payload);
export const deleteTable = (tableId: string | number) => api.delete(url.TABLE(tableId));

// Zones
export const getZones = (params?: Record<string, any>) => api.get(url.GET_ZONES, params ?? {});
export const getZone = (zoneId: string | number) => api.get(url.ZONE(zoneId), {});
export const createZone = (payload: any) => api.create(url.CREATE_ZONE, payload);
export const updateZone = (zoneId: string | number, payload: any) =>
    api.update(url.ZONE(zoneId), payload);
export const deleteZone = (zoneId: string | number) => api.delete(url.ZONE(zoneId));

// Notifications
export const getNotifications = (params?: Record<string, any>) => api.get(url.NOTIFICATIONS, params ?? {});
export const markNotificationRead = (notificationId: string | number) =>
    api.put(url.NOTIFICATION_MARK_READ(notificationId), {});
export const markAllNotificationsRead = () => api.put(url.NOTIFICATIONS_MARK_READ_ALL, {});
export const getUnreadNotificationsCount = () => api.get(url.NOTIFICATIONS_UNREAD_COUNT, {});
export const getNotificationSettings = () => api.get(url.NOTIFICATION_SETTINGS, {});
export const updateNotificationSettings = (payload: Record<string, any>) =>
    api.put(url.NOTIFICATION_SETTINGS, payload);

// Web push subscriptions
export const saveWebPushSubscription = (subscription: PushSubscriptionJSON) =>
    api.create(url.WEBPUSH_SUBSCRIPTIONS, {
        endpoint: subscription?.endpoint,
        keys: subscription?.keys ?? {},
        expirationTime: subscription?.expirationTime ?? null,
    });
export const deleteWebPushSubscription = (endpoint: string) =>
    api.delete(url.WEBPUSH_SUBSCRIPTIONS, { data: { endpoint } });


export const submitFeedback = (payload: { title: string; content: string }) =>
    api.create(url.FEEDBACK, payload);

// Order board endpoints
export const getPaidOrders = (shopId: string | number, params?: Record<string, any>) =>
    api.get(url.GET_PAID_ORDERS(shopId), params ?? {});
export const getUnpaidOrders = (shopId: string | number, params?: Record<string, any>) =>
    api.get(url.GET_UNPAID_ORDERS(shopId), params ?? {});
export const getInProcessOrders = (shopId: string | number, params?: Record<string, any>) =>
    api.get(url.GET_IN_PROCESS_ORDERS(shopId), params ?? {});
export const getCompletedOrders = (shopId: string | number, params?: Record<string, any>) =>
    api.get(url.GET_COMPLETED_ORDERS(shopId), params ?? {});

// Reports
export const getRevenueByDayLastSevenDays = (shopId: string | number) =>
    api.get(url.REPORT_REVENUE_BY_DAY_LAST_SEVEN(shopId), {});
export const getRevenueByHourToday = (shopId: string | number) => api.get(url.REPORT_REVENUE_BY_HOUR_TODAY(shopId), {});
export const getRevenueByHourYesterday = (shopId: string | number) =>
    api.get(url.REPORT_REVENUE_BY_HOUR_YESTERDAY(shopId), {});
export const getRevenueByDayThisMonth = (shopId: string | number) =>
    api.get(url.REPORT_REVENUE_BY_DAY_THIS_MONTH(shopId), {});
export const getRevenueByDayLastMonth = (shopId: string | number) =>
    api.get(url.REPORT_REVENUE_BY_DAY_LAST_MONTH(shopId), {});
export const getOrderQuantityByDayLastSevenDays = (shopId: string | number) =>
    api.get(url.REPORT_ORDER_BY_DAY_LAST_SEVEN(shopId), {});
export const getOrderQuantityByHourToday = (shopId: string | number) =>
    api.get(url.REPORT_ORDER_BY_HOUR_TODAY(shopId), {});
export const getOrderQuantityByHourYesterday = (shopId: string | number) =>
    api.get(url.REPORT_ORDER_BY_HOUR_YESTERDAY(shopId), {});
export const getOrderQuantityByDayThisMonth = (shopId: string | number) =>
    api.get(url.REPORT_ORDER_BY_DAY_THIS_MONTH(shopId), {});
export const getOrderQuantityByDayLastMonth = (shopId: string | number) =>
    api.get(url.REPORT_ORDER_BY_DAY_LAST_MONTH(shopId), {});


// Table QR
export const getTableQrs = () => api.get(url.TABLE_QRS, {});
export const createTableQr = (payload: { table_id: string | number }) => api.create(url.TABLE_QRS, payload);
export const deleteTableQr = (id: string | number) => api.delete(url.TABLE_QR(id));
export const resolveTableQr = (token: string) => api.get(url.RESOLVE_TABLE_QR(token), {});
export const verifyTableQr = (payload: { url: string }) => api.create(url.VERIFY_TABLE_QR, payload);


// Shop members
export const getShopMembers = () => api.get(url.SHOP_MEMBERS, {});
export const deleteShopMember = (userId: string | number) => api.delete(url.SHOP_MEMBER(userId));

export const getSubscriptionPaymentStatusById = (paymentTransactionId: string | number) =>
    api.get(url.PAYMENT_STATUS_BY_ID(paymentTransactionId), {});

